import { render, staticRenderFns } from "./MainNavbarChadAbout.vue?vue&type=template&id=2c6c94ae&scoped=true&"
import script from "./MainNavbarChadAbout.vue?vue&type=script&lang=js&"
export * from "./MainNavbarChadAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6c94ae",
  null
  
)

export default component.exports